import React from "react";
// reactstrap components
import {
    Button,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Modal,
    Pagination,
    PaginationItem,
    PaginationLink,
    Row,
    Table,
} from "reactstrap";
import {MdClose, MdFileDownload, MdFilterList, MdGroup, MdPersonAdd} from 'react-icons/md';
// core components
import ClientsHeader from "../../components/Headers/ClientsHeader.js";
import ClientTableRow from "../../components/Tables/ClientTableRow";
import {Redirect} from "react-router-dom";
import {RotateCircleLoading} from "react-loadingg";

import {confirmAlert} from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import localeHelpers from "../../helpers/LocaleHelper";
import stringHelpers from "../../helpers/StringHelper";
import ErrorModal from "../../components/Alerts/ErrorModal";
import StudentApiService from "../../api/student-api-service";
import subscriptionHelpers from "../../helpers/SubscriptionHelper";
import LocalizedStrings from "react-localization";
import {student_strings} from "../../translations/student_translations";
import {alert_strings} from "../../translations/alert_translations";
import {resource_strings} from "../../translations/resource_translations";
import {common_strings} from "../../translations/common_translations";
import RanksOverview from "../../components/Resources/Student/RanksOverview";
import NotProModal from "../../components/Alerts/NotProModal";
import businessApiService from "../../api/business-api-service";
import LoadingOverlay from "react-loading-overlay";
import {report_strings} from "../../translations/report_translations";
import groupHelpers from "../../helpers/GroupHelper";
import RankTableRowFilters from "../../components/Tables/RankTableRowFilters";
import Label from "reactstrap/es/Label";
import HeaderAlert from "../../components/Alerts/SuccessAlert";
import reportApiService from "../../api/report-api-service";
import RewardOverview from "../../components/Resources/Student/RewardOverview";
import moment from "moment";
import {DateRangePicker} from "react-dates";
import businessHelper from "../../helpers/BusinessHelper";

let studentStrings = new LocalizedStrings(student_strings);
let alertStrings = new LocalizedStrings(alert_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let reportStrings = new LocalizedStrings(report_strings);
let commonStrings = new LocalizedStrings(common_strings);

let filterTimeout;

class Clients extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputStarted: false,
            activePagTab: 1,
            firstPagTab: 1,
            page: 1,
            total: 0,
            active: 0,
            suelta: 0,
            clients: [],
            goToClientCreation: false,
            goToClient: false,
            goToClientId: false,
            showError: false,
            showMessageModal: false,
            showExportModal: false,
            showNotProModal: false,
            error: null,
            alertData: null,
            selectedRank: null,
            showRanksView: false,
            activeOnly: false,
            sueltaOnly: false,
            forceRequestStudents: false,
            showFilters: false,
            filters: props.location.state && props.location.state.filters ? props.location.state.filters :
                {
                    groups: null,
                    newOnly: false,
                    deletedOnly: false,
                    blocked: false,
                    showAdvanced: false,
                    dropping: false,
                    dropping_active: false,
                    dropping_this_month: false,
                    topFifty: false,
                    loyalNoTicket: false,
                },
            includeDeletedClients: props.location.state ? props.location.state.includeDeletedClients : false,
            searchValue: props.location.state ? props.location.state.searchValue : "",
            message: {
                title: "",
                message: ""
            },
        };
        this.tableRef = React.createRef();
        this.goToClient = this.goToClient.bind(this);
        this.onShowAll = this.onShowAll.bind(this);

        this.handleLanguageChange = this.handleLanguageChange.bind(this);
        this.showRanksView = this.showRanksView.bind(this);
        this.showMessage = this.showMessage.bind(this);
        this.handleMessageInputChange = this.handleMessageInputChange.bind(this);
        this.sendMessageAction = this.sendMessageAction.bind(this);

        window.ClientsView = this
    }

    componentWillUnmount() {
        window.ClientsView = null
    }

    handleLanguageChange(e) {
        e.preventDefault();
        let lang = e.target.value;
        this.setState(prevState => ({
            language: lang
        }))
    }


    handleChange = this.handleChange.bind(this);

    //confirmDeletion = this.confirmDeletion.bind(this);

    handleChange(event) {
        clearTimeout(filterTimeout)

        let searchValue = event.target.value;

        this.setState({
            searchValue: searchValue
        });

        if (searchValue.length > 1) {
            this.setState({
                inputStarted: true
            });

            filterTimeout = setTimeout(() => {
                this.search(searchValue)
            }, 500)

        } else if (searchValue.length === 0) {
            this.setState({
                searchValue: "",
                activePagTab: 1,
                firstPagTab: 1,
                inputStarted: false
            });

            this.getStudents()
        }
    }

    search(searchValue) {
        StudentApiService.search(searchValue, this.state.includeDeletedClients, this.state.activeOnly)
            .then(res => {
                let clients = res.students;

                this.setState({
                    clients: clients
                });

                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    goToClient(e, id) {
        e.preventDefault();
        e.stopPropagation();

        this.setState({
            goToClient: true,
            goToClientId: id,
        });
    }

    createClient(e) {
        e.preventDefault();

        if (this.canAddMoreClients()) {
            this.setState({
                goToClientCreation: true
            })
        } else {
            this.handleNetworkError({status: 928})
        }
    }

    clearSearch(e) {
        e.preventDefault();

        this.setState({
            searchValue: "",
            activePagTab: 1,
            firstPagTab: 1,
            inputStarted: false
        });

        this.getStudents()
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (this.state.activePagTab !== nextState.activePagTab) {
            if (this.state.filters.dropping || this.state.filters.dropping_active) {
                this.loadDroppingStudents(nextState.activePagTab)
                return
            }

            if (this.state.filters.dropping_this_month) {
                this.loadDroppingThisMonth(nextState.activePagTab)
                return
            }

            this.getStudents(nextState.activePagTab)
        }

        if (this.state.alertData != null) {
            this.setState({
                alertData: null
            });
        }
    }

    switchTab(e, value) {
        e.preventDefault();

        this.setState({
            activePagTab: value,
        });
    }

    movePagination(e, value) {
        e.preventDefault();

        let newValue = this.state.firstPagTab + value;
        let activeNewValue = this.state.activePagTab + value;
        this.setState({
            firstPagTab: newValue,
            activePagTab: activeNewValue
        });
    }

    shouldDisableForwardPagButton() {
        return this.state.activePagTab * 20 >= this.state.total;
    }

    deleteClient(e, id) {
        const p = this.state.activePagTab;
        e.preventDefault();
        e.stopPropagation();
        StudentApiService.deleteStudent(id)
            .then(res => {
                this.getStudents(p)
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    recoverClient(e, id) {
        const p = this.state.activePagTab;
        e.preventDefault();
        StudentApiService.recoverClient(id)
            .then(res => {
                this.getStudents(p)
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    loadDroppingStudents(page = null) {
        this.setState({
            clients: [],
            isLoading: true,
            forceRequestStudents: false,
        });

        const endpoint = this.state.filters.dropping_active ? StudentApiService.loadDroppingActive : StudentApiService.loadDroppingStudents;
        endpoint(page ? page : this.state.activePagTab)
            .then(res => {
                let clients = res.students;

                this.setState({
                    clients: clients,
                    selection_count: res.selection_count,
                });

                window.scrollTo(0, this.tableRef.current.offsetTop);
                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    loadTopFiftyStudents(page = null) {
        this.setState({
            clients: [],
            isLoading: true,
            forceRequestStudents: false,
        });

        StudentApiService.loadTopFiftyStudents()
            .then(res => {
                let clients = res.students;

                this.setState({
                    clients: clients,
                    selection_count: res.selection_count,
                });

                window.scrollTo(0, this.tableRef.current.offsetTop);
                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    loadLoyalNoTicketStudents(page = null) {
        this.setState({
            clients: [],
            isLoading: true,
            forceRequestStudents: false,
        });

        StudentApiService.loadLoyalNoTicketStudents()
            .then(res => {
                let clients = res.students;

                this.setState({
                    clients: clients,
                    selection_count: res.selection_count,
                });

                window.scrollTo(0, this.tableRef.current.offsetTop);
                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    loadDroppingThisMonth(page = null) {
        this.setState({
            clients: [],
            isLoading: true,
            forceRequestStudents: false,
        });

        StudentApiService.loadDroppingThisMonth(page ? page : this.state.activePagTab)
            .then(res => {
                let clients = res.students;

                this.setState({
                    clients: clients,
                    selection_count: res.selection_count,
                });

                window.scrollTo(0, this.tableRef.current.offsetTop);
                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    getStudents(page = 1) {
        if (this.state.filters.topFifty) {
            this.loadTopFiftyStudents()
            return
        }

        if (this.state.filters.loyalNoTicket) {
            this.loadLoyalNoTicketStudents()
            return
        }

        if (this.state.filters.dropping || this.state.filters.dropping_active) {
            this.loadDroppingStudents()
            return
        }

        if (this.state.filters.dropping_this_month) {
            this.loadDroppingThisMonth()
            return
        }

        this.setState({
            clients: [],
            page: page,
            isLoading: true,
            forceRequestStudents: false,
        });

        StudentApiService.getStudents(page, this.state.includeDeletedClients, this.state.activeOnly, this.state.filters, this.state.filters.newOnly, this.state.filters.deletedOnly, this.state.sueltaOnly, this.state.filters.blocked, this.state.filters.start, this.state.filters.end)
            .then(res => {
                let clients = res.students;
                let total = res.total;
                let active = res.active;
                let suelta = res.suelta || 0;

                this.setState({
                    clients: clients,
                    total: total,
                    active: active,
                    suelta: suelta,
                    selection_count: res.selection_count,
                });

                window.scrollTo(0, this.tableRef.current.offsetTop);
                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.includeDeletedClients !== this.state.includeDeletedClients
            || prevState.activeOnly !== this.state.activeOnly
            || prevState.sueltaOnly !== this.state.sueltaOnly
            || prevState.filters.newOnly !== this.state.filters.newOnly
            || prevState.filters.deletedOnly !== this.state.filters.deletedOnly
            || prevState.filters.blocked !== this.state.filters.blocked
            || prevState.filters.dropping !== this.state.filters.dropping
            || prevState.filters.dropping_active !== this.state.filters.dropping_active
            || prevState.filters.dropping_this_month !== this.state.filters.dropping_this_month
            || prevState.filters.topFifty !== this.state.filters.topFifty
            || prevState.filters.loyalNoTicket !== this.state.filters.loyalNoTicket
            || (this.state.forceRequestStudents === true)
            || (this.datesAreUpdated(prevState.filters))
        ) this.getStudents()
    }

    componentDidMount() {
        reportApiService.ahoy("clients_view")
        moment.locale(businessHelper.business().locale)

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        } else {
            if (this.state.searchValue && this.state.searchValue.length > 0) {
                this.search(this.state.searchValue)
            } else this.getStudents();
        }
    }

    renderTableData() {
        return this.state.clients.map((student, index) => {
            return (
                <ClientTableRow client={student} key={student.id} goToClient={this.goToClient}
                                deleteClient={this.confirmDeletion}
                                recoverClient={this.recoverClient.bind(this)}
                />
            )
        })
    }

    confirmDeletion = (event, client) => {
        event.stopPropagation();

        confirmAlert({
            title: alertStrings.confirmation_alert_title,
            message: alertStrings.formatString(alertStrings.confirm_delete_student, client.name),
            buttons: [
                {
                    label: alertStrings.yes,
                    onClick: () => this.deleteClient(event, client.id)
                },
                {
                    label: alertStrings.no,
                    onClick: () => {
                    }
                }
            ]
        });
    };

    localize() {
        const loc = localeHelpers.currentLocale();

        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        reportStrings.setLanguage(loc);
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    includeDeleted() {
        this.setState({includeDeletedClients: !this.state.includeDeletedClients, searchValue: ""})
    }

    onActiveSelected() {
        this.setState({sueltaOnly: false, activeOnly: true, page: 1})
    }

    onSueltaSelected() {
        this.setState({activeOnly: false, sueltaOnly: true, page: 1})
    }

    onNewSelected() {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                newOnly: true
            },
            forceRequestStudents: true,
        }));
    }

    onDeletedSelected() {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                deletedOnly: true
            },
            forceRequestStudents: true,
        }));
    }

    onBlockedSelected() {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                blocked: true
            },
            forceRequestStudents: true,
        }));
    }

    onDroppingSelected() {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                dropping: true,
                dropping_active: false,
                dropping_this_month: false,
                blocked: false,
                newOnly: false,
                deletedOnly: false,
                topFifty: false,
                loyalNoTicket: false,
            },
            forceRequestStudents: true,
        }));
    }

    onDroppingDeselected() {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                dropping: false
            },
            forceRequestStudents: true,
        }));
    }

    onDroppingActiveSelected() {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                dropping: false,
                dropping_active: true,
                dropping_this_month: false,
                blocked: false,
                newOnly: false,
                deletedOnly: false,
                topFifty: false,
                loyalNoTicket: false,
            },
            forceRequestStudents: true,
        }));
    }

    onDroppingActiveDeselected() {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                dropping_active: false
            },
            forceRequestStudents: true,
        }));
    }

    onDroppingThisMonthSelected() {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                dropping: false,
                dropping_active: false,
                dropping_this_month: true,
                blocked: false,
                newOnly: false,
                deletedOnly: false,
                topFifty: false,
                loyalNoTicket: false,
            },
            forceRequestStudents: true,
        }));
    }

    onTopFiftySelected() {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                dropping: false,
                dropping_active: false,
                dropping_this_month: false,
                topFifty: true,
                blocked: false,
                newOnly: false,
                deletedOnly: false,
                loyalNoTicket: false,
            },
            showFilters: false,
            forceRequestStudents: true,
        }));
    }

    onTopFiftyDeselected() {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                topFifty: false
            },
            forceRequestStudents: true,
        }));
    }

    onLoyalNoTicketSelected() {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                dropping: false,
                dropping_active: false,
                dropping_this_month: false,
                topFifty: false,
                blocked: false,
                newOnly: false,
                deletedOnly: false,
                loyalNoTicket: true
            },
            showFilters: false,
            forceRequestStudents: true,
        }));
    }

    onLoyalNoTicketDeselected() {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                loyalNoTicket: false
            },
            forceRequestStudents: true,
        }));
    }

    onDroppingThisMonthDeselected() {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                dropping_this_month: false
            },
            forceRequestStudents: true,
        }));
    }

    onActiveDeselected() {
        this.setState({sueltaOnly: false, activeOnly: false, page: 1})
    }

    onNewDeselected() {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                newOnly: false
            },
            forceRequestStudents: true,
        }));
    }

    onDeletedDeselected() {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                deletedOnly: false
            },
            forceRequestStudents: true,
        }));
    }

    onBlockedDeselected() {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                blocked: false
            },
            forceRequestStudents: true,
        }));
    }

    render() {
        this.localize();

        if (this.state.goToClientCreation === true) {
            //return <Redirect from="*" to={"/admin/student-profile?name=" + this.state.searchValue}/>
            return <Redirect from="*" to={{
                pathname: "/admin/student-profile",
                state: {
                    newClientName: this.state.searchValue
                }
            }}/>
        }

        if (this.state.goToClient === true) {
            //return <Redirect from="*" to={`/admin/student-profile?id=${this.state.goToClientId}`}/>
            return <Redirect from="*" to={{
                pathname: "/admin/student-profile",
                state: {
                    clientId: this.state.goToClientId,
                    searchValue: this.state.searchValue,
                    includeDeletedClients: this.state.includeDeletedClients,
                    filters: this.state.filters,
                }
            }}/>
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <>

                    <ClientsHeader total={this.state.total} active={this.state.active} suelta={this.state.suelta}
                                   onActiveSelected={this.onActiveSelected.bind(this)}
                                   onSueltaSelected={this.onSueltaSelected.bind(this)}
                                   onActiveDeselected={this.onActiveDeselected.bind(this)}
                                   activeOnly={this.state.activeOnly}
                                   sueltaOnly={this.state.sueltaOnly}
                    />

                    {/* Page content */}
                    <Container className="mt--7" fluid>

                        {this.state.showError &&
                        <ErrorModal showError={this.state.showError} error={this.state.error}
                                    toggleErrorModal={() => this.toggleErrorModal()}/>
                        }

                        {this.state.showRanksView &&
                        this.renderRanksModal()
                        }

                        {this.state.showRewardModal &&
                        this.renderRewardsModal()
                        }

                        {this.state.showMessageModal == true &&
                        this.renderSendMessageModal()
                        }

                        {this.state.showFilters &&
                        this.renderFilterModal()
                        }

                        {this.state.showExportModal === true &&
                        this.renderExportDataModal()
                        }

                        {this.state.showNotProModal === true &&
                        <NotProModal showNotProModal={this.state.showNotProModal}
                                     toggleNotProModal={() => this.toggleNotProModal()}/>}

                        <Row>
                            <Col lg="6" className="mt-2">
                                <FormGroup className="mb-0" style={{marginTop: "4px"}}>
                                    <InputGroup className="input-group-alternative">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                <i className="fas fa-search"/>
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            value={this.state.searchValue}
                                            onChange={this.handleChange}
                                            placeholder={commonStrings.search_or_add} type="text"/>

                                        {this.state.inputStarted &&
                                        <InputGroupAddon addonType="append" onClick={e => this.clearSearch(e)}>
                                            <InputGroupText>
                                                <i className="fas fa-times-circle"/>
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        }
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="6" className="mt-2">
                                <Button
                                    style={{marginTop: "4px"}}
                                    color="success"
                                    onClick={e => this.createClient(e)}
                                >
                                    <span className="d-none d-md-block">
                                        <MdPersonAdd/> {commonStrings.create_new}
                                    </span>
                                    <span className="d-md-none">
                                        <MdPersonAdd/>
                                    </span>
                                </Button>

                                <Button
                                    style={{marginTop: "4px"}}
                                    color="secondary"
                                    onClick={e => this.showRanksView(e)}
                                >
                                    <span className="d-none d-md-block">
                                        <MdGroup/> {commonStrings.manage_ranks}
                                    </span>
                                    <span className="d-md-none">
                                        <MdGroup/>
                                    </span>
                                </Button>

                                <Button
                                    style={{marginTop: "4px"}}
                                    color={this.filtersAreOn() ? "danger" : "info"}
                                    onClick={this.prepareAndShowFilters.bind(this)}
                                >
                                    <span className="d-none d-md-block">
                                        <MdFilterList/> {reportStrings.filter}
                                    </span>
                                    <span className="d-md-none">
                                        <MdFilterList/>
                                    </span>
                                </Button>

                                <Button
                                    style={{marginTop: "4px"}}
                                    color="secondary"
                                    onClick={this.showRewardModal.bind(this)}
                                >
                                    <img
                                        width={20}
                                        height={20}
                                        alt="pm"
                                        src={require("assets/img/icons/rewards/069-medal-20.svg").default}
                                    />
                                </Button>

                                <Button
                                    style={{marginTop: "4px"}}
                                    color="warning"
                                    onClick={this.showExportModal.bind(this)}
                                >
                                    <MdFileDownload/>
                                </Button>
                            </Col>
                        </Row>

                        {/* Table */}
                        {/* Dark table */}
                        <Row className="mt-5">
                            <div className="col">
                                <Card className="bg-default shadow">
                                    <CardHeader className="bg-transparent border-0">
                                        <Row>
                                            <h3 className="text-white ml-2 mb-0"> {stringHelpers.capitalize(studentStrings.students)} {this.student_count()}</h3>
                                            {/*<h3 className="text-white mb-0"> {stringHelpers.capitalize(studentStrings.students)}</h3>*/}
                                            {this.filtersAreOn() &&
                                            <Button
                                                onClick={(e) => this.onShowAll(e)}
                                                color="info"
                                                className="ml-2"
                                                size="sm">
                                                {commonStrings.show_all}
                                            </Button>
                                            }
                                        </Row>

                                    </CardHeader>
                                    <div ref={this.tableRef}/>

                                    {this.state.alertData &&
                                    <HeaderAlert alertData={this.state.alertData}/>
                                    }
                                    <div style={{width: "100%"}}>
                                        {this.renderTableData()}
                                    </div>
                                    <CardFooter className="bg-default shadow py-4">
                                        <nav aria-label="...">
                                            {this.state.inputStarted === false &&
                                            <Pagination
                                                className="pagination justify-content-end mb-0"
                                                listClassName="justify-content-end mb-0"
                                            >
                                                <PaginationItem
                                                    className={this.state.firstPagTab === 1 ? "disabled" : null}>
                                                    <PaginationLink
                                                        href="#pablo"
                                                        onClick={e => this.movePagination(e, -1)}
                                                        tabIndex="-1"
                                                    >
                                                        <i className="fas fa-angle-left"/>
                                                        <span className="sr-only">Previous</span>
                                                    </PaginationLink>
                                                </PaginationItem>

                                                <PaginationItem
                                                    className={this.state.activePagTab === this.state.firstPagTab ? "active" : ""}>
                                                    <PaginationLink
                                                        href="#pablo"
                                                        onClick={e => this.switchTab(e, this.state.firstPagTab)}
                                                    >
                                                        {this.state.firstPagTab}
                                                    </PaginationLink>
                                                </PaginationItem>

                                                <PaginationItem
                                                    className={this.state.activePagTab === this.state.firstPagTab + 1 ? "active" : null}>
                                                    <PaginationLink
                                                        href="#pablo"
                                                        onClick={e => this.switchTab(e, this.state.firstPagTab + 1)}
                                                    >
                                                        {this.state.firstPagTab + 1} <span
                                                        className="sr-only">(current)</span>
                                                    </PaginationLink>
                                                </PaginationItem>

                                                <PaginationItem
                                                    className={this.state.activePagTab === this.state.firstPagTab + 2 ? "active" : null}>
                                                    <PaginationLink
                                                        href="#pablo"
                                                        onClick={e => this.switchTab(e, this.state.firstPagTab + 2)}
                                                    >
                                                        {this.state.firstPagTab + 2}
                                                    </PaginationLink>
                                                </PaginationItem>

                                                <PaginationItem
                                                    className={this.shouldDisableForwardPagButton() ? "disabled" : null}>
                                                    <PaginationLink
                                                        href="#pablo"
                                                        onClick={e => this.movePagination(e, 1)}
                                                    >
                                                        <i className="fas fa-angle-right"/>
                                                        <span className="sr-only">Next</span>
                                                    </PaginationLink>
                                                </PaginationItem>
                                            </Pagination>
                                            }
                                        </nav>
                                        <Row className="my-4">
                                            <Col xs="12">
                                                <div
                                                    className="custom-control custom-control-alternative custom-checkbox">
                                                    <input
                                                        className="custom-control-input"
                                                        id="input-deleted-cb"
                                                        checked={this.state.includeDeletedClients}
                                                        onChange={this.includeDeleted.bind(this)}
                                                        type="checkbox"
                                                    />
                                                    <label
                                                        className="custom-control-label"
                                                        htmlFor="input-deleted-cb"
                                                    >
                                                <span className="text-white">
                                                  {studentStrings.include_deleted}
                                                </span>
                                                    </label>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardFooter>
                                </Card>
                            </div>
                        </Row>
                    </Container>
                </>
            </LoadingOverlay>

        );
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false})
    }

    canAddMoreClients() {
        const subscription = subscriptionHelpers.currentSubscription()

        if (!subscription) {
            return this.state.total < 100
        } else if (subscription.plan.includes("priv")) {
            return this.state.total < 500
        } else {
            return true
        }
    }

    // GROUPS

    showRanksView(e) {
        e.preventDefault();
        this.setState({showRanksView: true})
    }

    toggleRanksModal = state => {
        this.setState({
            showRanksView: !this.state.showRanksView
        });
    };

    toggleRewardModal = state => {
        this.setState({
            showRewardModal: !this.state.showRewardModal
        });
    };

    renderRanksModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showRanksView}
                toggle={() => this.toggleRanksModal("formModal")}
            >
                <div className="modal-header bg-default">
                    <h4 className="modal-title text-white" id="modal-title-notification">
                        {commonStrings.manage_ranks}
                    </h4>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleRanksModal()}
                    >
                        <span aria-hidden={true} style={{color: "white"}}>×</span>
                    </button>
                </div>
                <div className="modal-body p-0">
                    <Card className="bg-default shadow border-0">
                        <CardBody className="px-lg-5 mb-5 mt-0">
                            <RanksOverview showMessage={this.showMessage}/>
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    renderRewardsModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showRewardModal}
                toggle={() => this.toggleRewardModal("formModal")}
            >
                <div className="modal-header">
                    <h6 className="modal-title" id="modal-title-notification">
                        <h4>{commonStrings.manage_rewards}</h4>
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleRewardModal()}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardBody className="px-lg-5 mb-5 mt-0">
                            <RewardOverview rewards={this.state.rewards} classTypes={this.state.classTypes}
                                            onRewardsUpdated={this.onRewardsUpdated}/>
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )

    }

    onRewardsUpdated = (rewards) => {
        this.setState({rewards: rewards})
    }

    onShowAll(e) {
        e.preventDefault();

        this.setState(prevState => ({
            activeOnly: false,
            sueltaOnly: false,
            filters: {
                ...prevState.filters,
                groups: null,
                newOnly: false,
                deletedOnly: false,
                blocked: false,
                start: undefined,
                end: undefined,
                dropping: false,
                dropping_active: false,
                topFifty: false,
                loyalNoTicket: false,
                dropping_this_month: false,
            },
            forceRequestStudents: true,
        }));
    }

// MESSAGES

    toggleMessageModal = state => {
        this.setState({
            showMessageModal: !this.state.showMessageModal
        });
    };

    renderSendMessageModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showMessageModal}
                toggle={() => this.toggleMessageModal("formModal")}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-2">
                            <div className="text-muted text-center mt-2 mb-3">
                                <button
                                    aria-label="Close"
                                    className="close"
                                    data-dismiss="modal"
                                    type="button"
                                    onClick={() => this.toggleMessageModal("notificationModal")}
                                >
                                    <span aria-hidden={true}>×</span>
                                </button>
                                <h4>{commonStrings.send_message}</h4>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            <div className="text-center text-muted mt--2 mb-4">
                                <small>{resourceStrings.message_will_be_sent_groups}</small>
                            </div>
                            <Form role="form">
                                <FormGroup className="mb-3">
                                    <InputGroup className="input-group-alternative">
                                        <Input placeholder={resourceStrings.title} type="text"
                                               id="message-input-title"
                                               defaultValue={this.state.message.title}
                                               onChange={this.handleMessageInputChange}/>
                                    </InputGroup>
                                </FormGroup>
                                <FormGroup>
                                    <InputGroup className="input-group-alternative">
                                        <Input placeholder={commonStrings.message}
                                               type="textarea" rows="5"
                                               id="message-input-text"
                                               defaultValue={this.state.message.message}
                                               onChange={this.handleMessageInputChange}/>
                                    </InputGroup>
                                </FormGroup>
                                <div className="text-center">
                                    {this.state.message && this.state.message.message && this.state.message.message.length > 10 &&
                                    <Button
                                        className="my-4"
                                        color="primary"
                                        type="button"
                                        onClick={e => this.sendMessageAction(e)}
                                    >
                                        {commonStrings.send}
                                    </Button>
                                    }
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    showMessage(e, rank) {
        e.preventDefault();
        if (subscriptionHelpers.hasSubscription()) this.setState({showMessageModal: true, selectedRank: rank})
        else this.setState({showNotProModal: true})
    }

    toggleNotProModal() {
        this.setState({showNotProModal: false})
    }

    sendMessageAction(e) {
        e.preventDefault();

        this.toggleMessageModal("")

        this.setState({
            isLoading: true,
            showRanksView: false,
        });

        businessApiService.sendMessage(this.state.selectedRank.id, this.state.message)
            .then(res => {
                this.setState({
                    isLoading: false,
                    showMessageModal: false,
                    alertData: {
                        type: 'success',
                        text: `${alertStrings.message_sent_success}`
                    }
                });

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    handleMessageInputChange(event) {
        this.setState({
            profileWasUpdated: true,
        });

        let newValue = event.target.value;
        let targetId = event.target.id;

        switch (targetId) {
            case "message-input-title":
                this.setState(prevState => ({
                    message: {
                        ...prevState.message,
                        title: newValue
                    }
                }));
                break;
            case "message-input-text":
                this.setState(prevState => ({
                    message: {
                        ...prevState.message,
                        message: newValue
                    }
                }));
                break;
            default:
                return
        }
    }

// FILTERS

    handleGroupSelected(checked, group) {
        const selected = ((this.state.filters.groups) ? this.state.filters.groups : []);
        const selectedValues = ((this.state.filters.groups) ? this.state.filters.groups : []).map(it => it.id);

        if (checked) {
            if (!selectedValues.includes(group.id)) {
                selected.push(group);
            }
        } else {
            if (selectedValues.includes(group.id)) {
                const index = selectedValues.indexOf(group.id);
                if (index !== -1) selected.splice(index, 1);
            }
        }

        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                groups: selected
            },
            forceRequestStudents: true,
        }));
    }

    renderFilterModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showFilters}
                toggle={() => this.toggleFilters("formModal")}
            >
                <div className="modal-header bg-gradient-default">
                    <h6 className="modal-title" id="modal-title-notification">
                        <h4 className="text-white">{reportStrings.filter}</h4>
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleFilters()}
                    >
                        <span aria-hidden={true} style={{color: 'white'}}>×</span>
                    </button>
                </div>
                <div className="p-0 bg-gradient-default">

                    <div className="custom-control custom-control-alternative custom-checkbox mx-4 text-white my-1">
                        <input
                            className="custom-control-input"
                            id="filter-active"
                            onChange={e => e.target.checked ? this.onActiveSelected() : this.onActiveDeselected()}
                            checked={this.state.activeOnly}
                            type="checkbox"
                        />
                        <label className="custom-control-label" htmlFor="filter-active">
                            {studentStrings.clients_active}
                        </label>
                    </div>

                    <div
                        className="custom-control custom-control-alternative custom-checkbox mx-4 text-white mt-2">
                        <input
                            className="custom-control-input"
                            id="filter-new"
                            onChange={e => e.target.checked ? this.onNewSelected() : this.onNewDeselected()}
                            checked={this.state.filters.newOnly}
                            type="checkbox"
                        />
                        <label className="custom-control-label" htmlFor="filter-new">
                            {studentStrings.clients_new}
                        </label>
                    </div>

                    <div
                        className="custom-control custom-control-alternative custom-checkbox mx-4 text-white mt-2">
                        <input
                            className="custom-control-input"
                            id="filter-deleted"
                            onChange={e => e.target.checked ? this.onDeletedSelected() : this.onDeletedDeselected()}
                            checked={this.state.filters.deletedOnly}
                            type="checkbox"
                        />
                        <label className="custom-control-label" htmlFor="filter-deleted">
                            {studentStrings.clients_deleted}
                        </label>
                    </div>

                    <div
                        className="custom-control custom-control-alternative custom-checkbox mx-4 text-white mt-2 mb-4">
                        <input
                            className="custom-control-input"
                            id="filter-blocked"
                            onChange={e => e.target.checked ? this.onBlockedSelected() : this.onBlockedDeselected()}
                            checked={this.state.filters.blocked}
                            type="checkbox"
                        />
                        <label className="custom-control-label" htmlFor="filter-blocked">
                            {studentStrings.clients_blocked}
                        </label>
                    </div>

                    <Button size="sm" style={{marginLeft: 24}} onClick={e => this.toggleShowAdvanced(e)}>
                        {this.state.filters.showAdvanced ?
                            (<>
                                <i className="fas fa-arrow-alt-circle-up mr-2"/>{commonStrings.hide_advanced} </>) :
                            (<>
                                <i className="fas fa-arrow-alt-circle-down mr-2"/>{commonStrings.show_advanced} </>)
                        }
                    </Button>

                    {this.state.filters.showAdvanced &&
                    <div
                        style={{
                            display: "flex",
                            flexFlow: "column",
                            alignItems: "start",
                            marginLeft: 25,
                            marginTop: 20
                        }}>

                        <div
                            className="custom-control custom-control-alternative custom-checkbox text-white mt-2 mb-2">
                            <input
                                className="custom-control-input"
                                id="filter-dropping"
                                onChange={e => e.target.checked ? this.onDroppingSelected() : this.onDroppingDeselected()}
                                checked={this.state.filters.dropping}
                                type="checkbox"
                            />
                            <label className="custom-control-label" htmlFor="filter-dropping">
                                {reportStrings.students_not_active_30_days}
                            </label>
                        </div>

                        <div
                            className="custom-control custom-control-alternative custom-checkbox text-white mt-2 mb-2">
                            <input
                                className="custom-control-input"
                                id="filter-dropping-active"
                                onChange={e => e.target.checked ? this.onDroppingActiveSelected() : this.onDroppingActiveDeselected()}
                                checked={this.state.filters.dropping_active}
                                type="checkbox"
                            />
                            <label className="custom-control-label" htmlFor="filter-dropping-active">
                                {reportStrings.students_not_active_10_days_active}
                            </label>
                        </div>

                        <div
                            className="custom-control custom-control-alternative custom-checkbox text-white mt-2 mb-4">
                            <input
                                className="custom-control-input"
                                id="filter-dropping-this-month"
                                onChange={e => e.target.checked ? this.onDroppingThisMonthSelected() : this.onDroppingThisMonthDeselected()}
                                checked={this.state.filters.dropping_this_month}
                                type="checkbox"
                            />
                            <label className="custom-control-label" htmlFor="filter-dropping-this-month">
                                {reportStrings.students_not_active_this_moth}
                            </label>
                        </div>

                        <div
                            className="custom-control custom-control-alternative custom-checkbox text-white mt-2 mb-2">
                            <input
                                className="custom-control-input"
                                id="filter-top-fifty"
                                onChange={e => e.target.checked ? this.onTopFiftySelected() : this.onTopFiftyDeselected()}
                                checked={this.state.filters.topFifty}
                                type="checkbox"
                            />
                            <label className="custom-control-label" htmlFor="filter-top-fifty">
                                {reportStrings.top_fifty_students}
                            </label>
                        </div>

                        <div
                            className="custom-control custom-control-alternative custom-checkbox text-white mt-2 mb-2">
                            <input
                                className="custom-control-input"
                                id="filter-loyal-no-ticket"
                                onChange={e => e.target.checked ? this.onLoyalNoTicketSelected() : this.onLoyalNoTicketDeselected()}
                                checked={this.state.filters.loyalNoTicket}
                                type="checkbox"
                            />
                            <label className="custom-control-label" htmlFor="filter-loyal-no-ticket">
                                {reportStrings.loyal_no_ticket}
                            </label>
                        </div>

                        <label className="text-white">{reportStrings.created_between}</label>
                        <span style={{display: "flex", flexFlow: "row", justifyContent: "start", alignItems: "center"}}>
                        <DateRangePicker
                            style={{borderRadius: 20}}
                            startDate={moment(this.state.filters.start)} // momentPropTypes.momentObj or null,
                            startDateId="start_date_input" // PropTypes.string.isRequired,
                            endDate={moment(this.state.filters.end)} // momentPropTypes.momentObj or null,
                            endDateId="end_date_input" // PropTypes.string.isRequired,
                            onDatesChange={({startDate, endDate}) => this.updateDates({
                                startDate,
                                endDate
                            })} // PropTypes.func.isRequired,
                            focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                            onFocusChange={focusedInput => this.setState({focusedInput})} // PropTypes.func.isRequired,\
                            enableOutsideDays={true}
                            isOutsideRange={() => false}
                            displayFormat={() => moment.localeData('en').longDateFormat('L')}
                        />
                            {(this.state.filters.start || this.state.filters.end) &&
                            <MdClose onClick={e => {
                                this.clearDates(e)
                            }} color="white" size={40} clasName="cu" style={{cursor: "pointer"}}/>}
                    </span>
                    </div>
                    }

                    <hr style={{backgroundColor: "white"}}/>
                    <div className="p-4">
                        {this.renderFilters()}
                    </div>
                </div>
            </Modal>
        )
    }

    clearDates(e) {
        e.preventDefault();
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                start: undefined,
                end: undefined,
            },
        }));
    }

    toggleShowAdvanced() {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                showAdvanced: !this.state.filters.showAdvanced
            },
        }));
    }

    updateDates(param) {
        if (param.startDate) {
            this.setState(prevState => ({
                filters: {
                    ...prevState.filters,
                    start: param.startDate,
                }
            }));
        }

        if (param.endDate) {
            this.setState(prevState => ({
                filters: {
                    ...prevState.filters,
                    end: param.endDate
                }
            }));
        }
    }

    renderFilters() {
        const selectedGroups = (this.state.filters.groups) ? this.state.filters.groups.map(it => it.id) : [];
        return groupHelpers.groups().length > 0 ? groupHelpers.groups()
            .map((rank, index) => {
                return (
                    <RankTableRowFilters rank={rank} key={rank.id}
                                         selected={selectedGroups.includes(rank.id)}
                                         handleGroupSelected={this.handleGroupSelected.bind(this)}
                    />
                )
            }) : <Label className="text-white mt-2"> {commonStrings.no_ranks_expl} </Label>
    }

    toggleFilters() {
        this.setState({showFilters: !this.state.showFilters});
    }

    prepareAndShowFilters() {
        this.toggleFilters();
    }

    showExportModal(e) {
        e.preventDefault();

        if (subscriptionHelpers.hasSubscription()) this.setState({showExportModal: true})
        else this.setState({showNotProModal: true})
    }

    showRewardModal(e) {
        e.preventDefault();
        this.getRewards()
    }

    toggleExportModal = state => {
        this.setState({
            showExportModal: !this.state.showExportModal
        });
    };

    renderExportDataModal() {
        return (<Modal
            className="modal-dialog-centered modal-warning"
            contentClassName="bg-gradient-warnin"
            isOpen={this.state.showExportModal}
            toggle={() => this.toggleExportModal("notificationModal")}
        >
            <div className="modal-header">
                <h6 className="modal-title" id="modal-title-notification">
                    {/*Your attention is required*/}
                </h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleExportModal("notificationModal")}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="py-3 text-center">
                    <i style={{color: "white", fontSize: 50}} className="fas fa-file-download"/>
                    <h4 className="heading mt-4">{alertStrings.confirmation_alert_title}</h4>
                    <p>
                        {alertStrings.clients_export_data_expl}
                    </p>
                </div>
            </div>
            <div className="modal-footer">
                <Button
                    className="text-white ml-auto"
                    color="link"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleExportModal("notificationModal")}
                >
                    {alertStrings.no}
                </Button>
                <Button className="btn-white" color="default" type="button"
                        onClick={this.exportDataAction.bind(this)}>
                    {alertStrings.yes}
                </Button>
            </div>
        </Modal>)
    }

    exportDataAction(e) {
        e.preventDefault();

        this.setState({isLoading: true, showExportModal: false,})

        if (this.state.filters.topFifty){
            StudentApiService.exportTopFifty()
                .then(res => {
                    this.setState({
                        isLoading: false,
                        showExportModal: false,
                        alertData: {
                            type: 'success',
                            text: `${alertStrings.class_export_data_success}`
                        }
                    });

                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });

            return
        }

        if (this.state.filters.loyalNoTicket){
            StudentApiService.exportLoyalNoTicket()
                .then(res => {
                    this.setState({
                        isLoading: false,
                        showExportModal: false,
                        alertData: {
                            type: 'success',
                            text: `${alertStrings.class_export_data_success}`
                        }
                    });

                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });

            return
        }

        StudentApiService.exportData(this.state.activeOnly)
            .then(res => {
                this.setState({
                    isLoading: false,
                    showExportModal: false,
                    alertData: {
                        type: 'success',
                        text: `${alertStrings.class_export_data_success}`
                    }
                });

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    filtersAreOn() {
        return (this.state.filters.groups && this.state.filters.groups.length > 0)
            || this.state.filters.newOnly
            || this.state.filters.deletedOnly
            || this.state.activeOnly
            || this.state.filters.blocked
            || this.state.filters.dropping
            || this.state.filters.dropping_active
            || this.state.filters.dropping_this_month
            || this.state.filters.topFifty
            || this.state.filters.loyalNoTicket
            || this.state.filters.start
            || this.state.filters.end
    }

    getRewards() {
        this.setState({isLoading: true})

        businessApiService.rewards()
            .then(res => {
                this.setState({
                    isLoading: false,
                    showRewardModal: true,
                    rewards: res.rewards || [],
                    classTypes: res.class_types
                });

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    datesAreUpdated(prevFilters) {
        if (!prevFilters.start && (!this.state.filters.start || !this.state.filters.end)) {
            return false
        } else {
            return this.state.filters.start != prevFilters.start || this.state.filters.end != prevFilters.end
        }
    }

    student_count() {
        if (this.state.selection_count && this.state.total && this.state.selection_count !== this.state.total) {
            return `(${this.state.selection_count})`
        } else return ''
    }
}

export default Clients;
